import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: 'minuteSecondsPipe'
})
export class MinuteSecondsPipe implements PipeTransform {

  transform(value): string {
    let seconds;
    let minutes;
    let hours;
    let duration: string = "";
    // const minutes: number = Math.floor(value / 60);
    // if(value != 0 && value != undefined){
    if (/^[0-9]+$/.test(value)) {
      hours = Math.floor(value / 3600);
      const min: number = Math.floor(value - hours * 3600);
      minutes = Math.floor(min / 60);
      seconds = Math.floor(min - minutes * 60);
      //	return hours + ':' + minutes + ':' + (value - minutes * 60);

      hours = hours.toString();

      minutes = minutes.toString();

      seconds = seconds.toString();

      if (hours != "0") {
        duration += hours + 'h';
      }
      if (minutes != "0") {
        duration += ' ' + minutes + 'm';
      }
      if (seconds != "0") {
        duration += ' ' + seconds + 's';
      }
      //return hours + ':' + minutes + ':' + seconds;
      return (duration == "") ? "0s" : duration;
    } else {
      return '';
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/pages/shared/pipes/second-to-minute.pipe.ts